enum FileUploadingStatus {
  UPLOADING = 'uploading',
  UPLOADED_TO_STORAGE = 'uploaded_to_storage',
  SUCCESS = 'success',
  ERROR = 'error',
}

export default FileUploadingStatus;
